import React, { useState, useMemo } from 'react';
import { Container, Col } from "react-bootstrap";
import { StyledKfTable } from '../../../../Styling/styledTable/StyledTable';
// import UseTableSorter from '../../../components/useTable/UseTable';
import usePaginator from '../../../../components/useTable/UsePaginator';
import UseTableSorter from '../../../../components/useTable/UseTable';
import { TableBorder, TitleSectionTables, KredittvurderingForm, KredittvurderingTd, StyledKvTable } from '../../../../Styling/styledKredittvurdering/styledKvComponents';


const RollerTable = (props) => {

    const localeMessages = props.localeMessages
    const kvState = props.kredittvurderingState;
    const ratingData = props.fetchedRating;

    // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('up'); // default
    const [currentField, setCurrentField] = useState('organisationName');    // feltnavn
    const [currentType, setCurrentType] = useState('string'); // num
    const [sortClicked, setSortClicked] = useState(0);

    const [masterT1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    // Nødvendig pga henting av memoised felt
    const t1ChangeSortField = (fieldName, fieldType) => {
        masterT1ChangeSortField(fieldName, fieldType)

        // Sett trigger for å tvinge memoized function til rerender
        setSortClicked(Date.now())
    }

    const sortedData = useMemo(
        () => {
            if (ratingData.length > 0) {
                return ratingData.sort(t1GetSortFunc().fn)
            }
            else {
                return []
            }
        },
        [ratingData, sortClicked]
    );

    // state for grid paginator
    const [numberPrPage, setNumberPerPage] = useState(5)
    const [activePage, setActivePage] = useState(1);

    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
        sortedData,
        numberPrPage, setNumberPerPage,
        activePage, setActivePage
    )
    
    const printHeader = (t1IndicaterIcon, t1ChangeSortField) => {
      return (
          <thead>
              <tr>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('organisationId', 'string')}>{localeMessages['GH_orgNumber']}{t1IndicaterIcon('organisationId')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('organisationName', 'string')}>{localeMessages['GH_foretaksnavn']}{t1IndicaterIcon('organisationName')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('description', 'string')}>{localeMessages['GH_beskrivelse']}{t1IndicaterIcon('description')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('dagligLeder', 'string')}>{localeMessages['GH_dagligLeder']}{t1IndicaterIcon('dagligLeder')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('styreleder', 'string')}>{localeMessages['GH_styreleder']}{t1IndicaterIcon('styreleder')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('styremedlem', 'string')}>{localeMessages['GH_styremedlem']}{t1IndicaterIcon('styremedlem')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('nestleder', 'string')}>{localeMessages['GH_nestleder']}{t1IndicaterIcon('nestleder')}</th>
              </tr>
          </thead>
      )
    }


    const printRow = (model) => {
        return (
            <tr key={model.i}>
               <KredittvurderingTd>{model.organisationId}</KredittvurderingTd>
               <KredittvurderingTd>{model.organisationName}</KredittvurderingTd>
               <KredittvurderingTd>{model.description}</KredittvurderingTd>
               <KredittvurderingTd>{model.dagligLeder}</KredittvurderingTd>
               <KredittvurderingTd>{model.styreleder}</KredittvurderingTd>
               <KredittvurderingTd>{model.styremedlem}</KredittvurderingTd>
               <KredittvurderingTd>{model.nestleder}</KredittvurderingTd>
           </tr>
        )
    }

    return (
        <>
            <Container fluid="true">
                <TableBorder>
                    <KredittvurderingForm>
                        <Col xs={12} md={12}>
                            <TitleSectionTables>Roller</TitleSectionTables>
                            <PaginationDropdown />
                            <StyledKvTable>
                                {printHeader(t1IndicaterIcon, t1ChangeSortField)}

                                <tbody>
                                    <Paginate>
                                        {/* paginate forventer en funksjon */}
                                        {row => printRow(row)}
                                    </Paginate>
                                </tbody>
                            </StyledKvTable>
                            <br />
                            <PaginationIndex />
                            <br />
                            <PaginationNav />
                            <br/>
                        </Col>
                    </KredittvurderingForm>
                </TableBorder>            
            </Container>

        </>
    )
}

export default RollerTable



